import { useState } from "react";

import NavbarItem from "../components/NavbarItem";

function Navbar() {

    const [hidden, setHidden] = useState(true);

    return <nav className="fixed flex-col w-full justify-between px-10 py-2 bg-two transition-all z-50">
        <div className="flex w-full justify-between">
                <NavbarItem className="font-bold text-xl" text="YONG SHUN JIE" to="main"/>
            <div className="hidden md:flex gap-5 underline">
                <NavbarItem text="ABOUT" to="about"/>
                <NavbarItem text="PROJECTS" to="projects"/>
                <NavbarItem text="CONTACT" to="contact"/>
                <NavbarItem className="font-bold" text="RESUME" />
            </div>
            <div className={`block md:hidden`}>
                <a href="#nav" onClick={() => setHidden(!hidden)}>
                    <svg xmlns="http://www.w3.org/2000/svg" className={`h-full w-7 ${hidden ? "rotate-0" : "rotate-180"} transition`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 13l-5 5m0 0l-5-5m5 5V6" />
                    </svg>
                </a>
            </div>
        </div>
        <div className={`block md:hidden ${hidden ? "h-0" : "h-screen"} flex flex-col overflow-y-hidden transition-height justify-center align-items gap-2 underline`}>
            <NavbarItem text="ABOUT" to="about"/>
            <NavbarItem text="PROJECTS" to="projects"/>
            <NavbarItem text="CONTACT" to="contact"/>
            <NavbarItem className="font-bold" text="RESUME"/>
        </div>
    </nav>
}

export default Navbar;